import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login'
import loginAdmin from '@/views/loginAdmin'
import home from '@/views/home'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',     //  后期上线改为login
    },
    {   //普通用户登录
      path: '/login',
      name: 'login',
      component: login
    },
    {   //管理员登录
      path: '/login_admin',
      name: 'loginAdmin',
      component: loginAdmin
    },
    {
      path: '/user',
      name: 'home',
      component: home,
      meta:{ neddLogin: true },
      children: [
        {
          path: '/user',
          name: '首页',     //  子账户展示
          component: () => import('@/views/user'),
        },
        {
          path: '/systemctl',
          name: '用户管理',
          component: () => import('@/views/system'),
        },
        {
          path: '/version',
          name: '版本管理',
          component: () => import('@/views/version'),
        }
      ]
    },
    {
      path: '403',
      name: '403',
      component: home,
      meta:{ neddLogin: true },
      children: [
        {
          path:'/403',
          name:'403',
          component: () => import('@/views/403'),
        },{
          path:'/404',
          name:'404',
          component: () => import('@/views/404'),
        }
      ]
    }
  ]
});
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     let token = localStorage.getItem('Authorization');
//     if (token === null || token === '') {
//       next('/login');
//     } else {
//       next();
//     }
//   }
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js